/* import __COLOCATED_TEMPLATE__ from './ai-score-pill.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    totalScore: number;
    recommendationCount: number;
    onClick: () => void;
  };
}

const AiScorePill = templateOnlyComponent<Signature>();
export default AiScorePill;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ContentReadiness::AiScorePill': typeof AiScorePill;
    'content-readiness/ai-score-pill': typeof AiScorePill;
  }
}
